import { FC, PropsWithChildren } from "react";

import "./ListItemNull.css";

export const ListItemNull: FC<PropsWithChildren<{}>> = ({ children }) => {
  return <div className="ListItemNull">{children}</div>;
};
